



































import { Component, Vue, Prop, PropSync } from 'vue-property-decorator';
import debounce from 'lodash.debounce';
import { Validation } from 'vuelidate';
import { ProductsApi, Product } from '@/api';

@Component
export default class UserSuggest extends Vue {
	// computed
	get validationState() {
		if (this.validator) {
			return this.validator.$dirty && this.validator.$invalid;
		}
		return null;
	}
	public collapseVisible = true;

	@PropSync('product')
	public localProduct!: Product;

	@Prop(Object)
	public readonly validator?: Validation;

	@Prop(Boolean)
	public readonly disabled?: boolean;

	@Prop(Boolean)
	public readonly state?: boolean;

	public options: Product[] = [];
	private api: ProductsApi;

	constructor() {
		super();
		this.api = new ProductsApi();
		this.debouncedOptions = debounce(this.fetchOptions, 100);
	}

	public clearProduct() {
		this.localProduct = { id: '', name: '', type: '', status: '', supplierNumber: '' };
		this.$emit('exist', false);
	}

	public onSelect(item: any) {
		if (this.validator) {
			this.validator.$touch();
		}
		this.collapseVisible = !this.collapseVisible;
		this.localProduct = item;
		this.$emit('exist', true);
	}

	public onSearch(search: string) {
		this.collapseVisible = true;
		if (!search || search.length < 1) {
			this.debouncedOptions.cancel();
			//   // loading(false);
			return;
		}
		this.debouncedOptions.cancel();
		this.debouncedOptions(search);
	}

	public async fetchOptions(search: string) {
		const options = {
			params: {
				'filter[name]': search,
				'fields[products]': 'id,name,type,supplierNumber,status',
			},
		};
		const response = await this.api.getProducts(options);
		const products = response.data.data || [];
		this.options = response.data.data || [];
	}

	private readonly debouncedOptions: any = () => {
		return [];
	};
}
